<template>
  <v-card class="mx-auto" :disabled="loading" :loading="loading">
    <v-card-title>
      รายงานนักศึกษาที่ยังไม่ลงทะเบียน + บันทึกรักษาสภาพ
    </v-card-title>

    <v-card-text class="px-1 px-md-3 px-xl-6">
      <v-tabs v-model="level_tab">
        <v-tabs-slider color="yellow"></v-tabs-slider>
        <v-tab v-for="(level, i) in levels" :key="i">
          <h3>
            {{ level.LEVEL_NAME_EN }}
          </h3>
        </v-tab>
      </v-tabs>

      <v-tabs-items v-model="level_tab" touchless>
        <v-tab-item v-for="(level, i) in levels" :key="i">
          <v-card flat>
            <v-card-text class="px-1 px-md-3 px-xl-6">
              <v-form v-model="form_validate_status" ref="form">
                <v-row>
                  <v-col cols="12" md="3">
                    <v-autocomplete
                      v-model="selected_faculty_id"
                      :items="faculty_list"
                      :item-value="(item) => item.faculty_id"
                      :item-text="(item) => item.faculty_name_th"
                      outlined
                      dense
                      label="คณะ"
                      hide-details
                      :rules="required"
                    />
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-autocomplete
                      v-model="selected_year"
                      :items="year_list"
                      outlined
                      dense
                      :label="$t('config_teach_table.year')"
                      hide-details
                      :rules="year_rules"
                    />
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-autocomplete
                      v-model="selected_semester"
                      :items="semesters"
                      outlined
                      dense
                      :label="$t('config_teach_table.semester')"
                      hide-details
                      :rules="semester_rules"
                    />
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-btn
                      outlined
                      color="green darken-3"
                      class="white--text"
                      @click="download()"
                      :disabled="data.length == 0"
                    >
                      ดาวน์โหลด<v-icon> mdi-microsoft-excel</v-icon>
                    </v-btn>
                  </v-col>
                </v-row>
                <v-row v-show="data.length > 0 && level.LEVEL_ID != 1">
                  <v-col cols="12" md="3">
                    <DateSelectCard
                      v-model="retire_date"
                      label="วันที่บันทึกพ้นสภาพ"
                      :maxDate="getYearsModified(1)"
                    />
                  </v-col>
                  <v-col cols="12" md="9">
                    <v-btn
                      color="success"
                      @click="setStudentStatus()"
                      :disabled="!retire_date"
                    >
                      บันทึกพ้นสภาพ
                    </v-btn>
                    <span class="red--text ml-2"
                      >***หมายเหตุ****
                      โปรดพิมพ์ข้อมูลรายชื่อเก็บไว้ก่อนบันทึกข้อมูล</span
                    >
                  </v-col>
                </v-row>
              </v-form>
              <v-simple-table
                min-height="300px"
                class="mt-3 text-no-wrap text-center"
                v-if="form_validate_status"
              >
                <thead class="blue-grey darken-1">
                  <tr>
                    <th class="white--text text-center font-weight-regular">
                      #
                    </th>
                    <th class="white--text text-center font-weight-regular">
                      รหัสนักศึกษา
                    </th>
                    <th class="white--text text-center font-weight-regular">
                      ชื่อ-สกุล
                    </th>
                    <th class="white--text text-center font-weight-regular">
                      สาขา
                    </th>
                    <th class="white--text text-center font-weight-regular">
                      การชำระเงิน
                    </th>
                    <th class="white--text text-center font-weight-regular">
                      ดำเนินการรักษาสภาพ
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="data.length == 0 && !loading">
                    <td colspan="10" class="last-cell">
                      <p class="text-center text-secondary mb-0">no result</p>
                    </td>
                  </tr>
                  <tr v-for="(item, index) in data" :key="index">
                    <td>{{ index + 1 }}</td>
                    <td>{{ item.student_id }}</td>
                    <td class="text-left">
                      <a
                        v-if="selected_level != 1"
                        :href="`https://www.reg.kmitl.ac.th/u_student_x/report_transcript_show.php?student_id=${item.student_id}`"
                        target="_blank"
                      >
                        {{
                          `${item.t_prename}${item.t_name} ${item.t_surname}`
                        }}
                      </a>
                      <span v-else
                        >{{
                          `${item.t_prename}${item.t_name} ${item.t_surname}`
                        }}
                      </span>
                    </td>
                    <td class="text-left">
                      {{ item.curr2_tname }}
                      <span v-if="item.level == 3">(ดุษฎีบัณฑิต)</span>
                    </td>
                    <td class="last-cell">
                      <router-link
                        :to="{ name: 'payment_officer', query: { student_id: item.student_id } }"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        รายละเอียด
                      </router-link>
                    </td>
                    <td class="last-cell">
                      <v-btn small color="warning" @click="maintain(item)"
                        >รักษาสภาพ</v-btn
                      >
                    </td>
                  </tr>
                </tbody>
              </v-simple-table>
            </v-card-text>
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </v-card-text>
  </v-card>
</template>

<script>
import dayjs from "dayjs";
import { dateTimeFromDBTranslatorFull as dt } from "@/helper/translator";
import GenericProvider from "@/services/generic.provider";
import ReportProvider from "@/services/report.provider";
import RegistrationProvider from "@/services/registration.provider.js";
import ExecuteProvider from "@/services/execute.provider.js";
import DateSelectCard from "@/components/info_cards/DateSelect";
import { getYearsModified } from "@/helper/dateTime";
import { studentStudy } from "./generate.js";

// const semesters = ["1", "2", "3"].sort((a, b) => b - a);
const genericService = new GenericProvider();
const ReportService = new ReportProvider();
const RegistrationService = new RegistrationProvider();
const ExecuteService = new ExecuteProvider();

export default {
  name: "StudentNotRegistered",
  data: () => ({
    loading: false,
    level_tab: 1,
    selected_level: null,
    selected_faculty_id: null,
    selected_year: null,
    selected_semester: "1",
    retire_date: null,

    // # ยังไม่เปิดให้ ปริญญาตรีใช้เนื่องจาก ของ ป.ตรีมีเงื่อนไขต่างไปจากนี้อยู่
    levels: [
      // {
      //   LEVEL_ID: "1",
      //   LEVEL_NAME_EN: "ปริญญาตรี",
      //   LEVEL_NAME_TH: "ปริญญาตรี",
      // },
      {
        LEVEL_ID: "2",
        LEVEL_NAME_EN: "บัณฑิตศึกษา",
        LEVEL_NAME_TH: "บัณฑิตศึกษา",
      },
    ],

    year_list: [],
    faculty_list: [],
    semesters: ["1", "2"],

    required: [(v) => !!v || "Required"],
    year_rules: [(v) => !!v || "Year is required"],
    semester_rules: [(v) => !!v || "Semester is required"],

    form_validate_status: false,

    data: [],
  }),
  components: {
    DateSelectCard,
  },

  methods: {
    dt,
    getYearsModified,

    async get_faculty() {
      const response = await genericService
        .getRegistrarFaculty()
        .catch((error) => {
          this.$toasted.error(JSON.stringify(error.response.data.message), {
            duration: 0,
          });
        });

      if (response) this.faculty_list = response;
    },

    get_years() {
      const maxYear = parseInt(dayjs().format("BBBB"));
      for (let year = 2550; year <= maxYear; year++) this.year_list.push(year);
      this.year_list.sort().reverse();
    },

    async getYearSemesterNow() {
      this.loading = true;
      const response = await RegistrationService.getYearSemesterNow(1).catch(
        (error) => {
          this.$toasted.error(JSON.stringify(error.response.data.message), {
            duration: 0,
          });
        }
      );

      if (response) {
        this.selected_year = parseInt(response.YEAR);
      }
      this.loading = false;
    },

    async maintain(item) {
      this.loading = true;
      this.is_open = false;

      const response = await RegistrationService.regisMaintainAndDrop({
        level_id: this.selected_level,
        year: this.selected_year,
        semester: this.selected_semester,
        student_id: item.student_id,
        regis_type: "M",
      }).catch((error) => {
        this.loading = false;
        this.$toasted.error(JSON.stringify(error.response.data.message), {
          duration: 0,
        });
      });

      if (response) {
        if (!response.status)
          this.$toasted.error("รักษาสภาพ " + item.student_id + " ไม่สำเร็จ", {
            duration: 0,
          });
        else {
          this.$toasted.clear();
          this.$toasted.success("รักษาสภาพ " + item.student_id + " สำเร็จ", {
            duration: 0,
          });
        }
      }

      this.loading = false;
      this.fetch_data();
    },

    async setStudentStatus() {
      this.loading = true;
      const list_student_id = this.data.map((item) => item.student_id);
      const response = await ExecuteService.setStudentStatus({
        level_id: this.selected_level,
        keyword:
          this.selected_level == 1
            ? "ungraduate-retire-not-registered"
            : "graduate-retire-not-registered",
        grad_year: this.selected_year,
        grad_semester: this.selected_semester,
        grad_date: this.retire_date,
        list_student_id,
      }).catch((error) => {
        this.loading = false;
        this.$toasted.error(JSON.stringify(error.response.data.message), {
          duration: 0,
        });
      });

      if (response) {
        if (!response.status)
          this.$toasted.error("บันทึกพ้นสภาพ ไม่สำเร็จ", {
            duration: 0,
          });
        else {
          this.$toasted.clear();
          this.$toasted.success("บันทึกพ้นสภาพ สำเร็จ", {
            duration: 0,
          });
        }
      }

      this.loading = false;
      this.fetch_data();
    },

    async fetch_data() {
      this.loading = true;

      const response = await ReportService.getReportStudentNotRegistered({
        level_id: this.selected_level,
        faculty_id: this.selected_faculty_id,
        year: this.selected_year,
        semester: this.selected_semester,
      }).catch((error) => {
        this.$toasted.error(JSON.stringify(error.response.data.message), {
          duration: 0,
        });
        this.loading = false;
      });

      if (response) this.data = response;

      this.loading = false;
    },

    clear_data() {
      this.data = [];
    },

    toggle_loading(status) {
      this.loading = status;
    },

    download() {
      const faculty_name = this.faculty_list.find(f => f.faculty_id === this.selected_faculty_id); 
      studentStudy(this.data, faculty_name.faculty_name_th, this.selected_year, this.selected_semester);  
      this.$toasted.success('ดาวน์โหลดข้อมูลนักศึกษาเรียบร้อยแล้ว', {
        duration: 3000,
      });
    },
  },

  watch: {
    form_validate_status: {
      handler: function (newVal) {
        this.clear_data();
        if (
          newVal === true &&
          this.selected_faculty_id !== null &&
          this.selected_year !== null &&
          this.selected_semester !== null
        )
          this.fetch_data();
      },
    },
    level_tab(newVal) {
      this.selected_level = this.levels[newVal].LEVEL_ID;
      this.selected_faculty_id = null;
    },
    selected_year: {
      handler: function () {
        this.clear_data();
        if (this.form_validate_status === true && this.selected_year !== null)
          this.fetch_data();
      },
    },
    selected_semester: {
      handler: function () {
        this.clear_data();
        if (
          this.form_validate_status === true &&
          this.selected_semester !== null
        )
          this.fetch_data();
      },
    },
    selected_faculty_id: {
      handler: function () {
        this.clear_data();
        if (
          this.form_validate_status === true &&
          this.selected_faculty_id !== null
        )
          this.fetch_data();
      },
    },
  },

  created() {
    this.get_faculty();
    this.get_years();
    this.getYearSemesterNow();
    this.selected_level = this.levels[this.level_tab].LEVEL_ID;
  },
};
</script>

<style>
th {
  letter-spacing: 1px;
}
.last-cell {
  border-right-width: 1px;
}
</style>
